import { render, staticRenderFns } from "./MaterialsManageAdd.vue?vue&type=template&id=004d94b9&scoped=true"
import script from "./MaterialsManageAdd.vue?vue&type=script&lang=js"
export * from "./MaterialsManageAdd.vue?vue&type=script&lang=js"
import style0 from "./MaterialsManageAdd.vue?vue&type=style&index=0&id=004d94b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d94b9",
  null
  
)

export default component.exports